module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_c('a', {
    attrs: {
      "id": "page_xix"
    }
  }), _c('em', [_vm._v("There’s but the twinkling of a star"), _c('br'), _vm._v("Between a man of peace and war.")]), _c('br'), _c('br'), _vm._v("—S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AMUEL")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UTLER")]), _vm._v(","), _c('br'), _c('em', [_vm._v("Hudibras II.")]), _vm._v(" Part iii. 957.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-561e2c79","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 84
// module chunks = 0